import { wellnub } from '../wellnub.api';

export const getNutritionistAppointments = async () => {
  const { data } = await wellnub.get(
    `/v1/nutritionist/wellnubService/nutritionistAppointment`,
  );
  return data;
};
